import PropTypes from 'prop-types';

import PropTypesPresenter from '../utils/PropTypesPresenter';

export default new PropTypesPresenter({
  id: PropTypes.string,
  name: PropTypes.string,
});
